import { useRouter } from 'next/router'
import type { BareFetcher, SWRConfiguration, SWRResponse } from 'swr'
import useSWR from 'swr'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { TEMPLATES_API } from '../api/templates-api'
import type { TemplatesCategoryInterface } from '../types/templates-category-interface'

export const useTemplateCategories = (): SWRResponse<
  TemplatesCategoryInterface[],
  unknown,
  | SWRConfiguration<
      TemplatesCategoryInterface[],
      unknown,
      BareFetcher<TemplatesCategoryInterface[]>
    >
  | undefined
> => {
  const { locale, isReady } = useRouter()
  const fetcherWithErrorValidation = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    TemplatesCategoryInterface[]
  >({ method: RequestMethodsEnum.get })
  return useSWR<TemplatesCategoryInterface[]>(() => {
    if (!isReady || !locale) return null
    return `${TEMPLATES_API}/filter/categories/${locale}`
  }, fetcherWithErrorValidation)
}
